// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lBe_oSTt_ZP6yOPJVcH0 {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.lBe_oSTt_ZP6yOPJVcH0 > .toggle {
  width: 44px;
  height: 24px;
}
.lBe_oSTt_ZP6yOPJVcH0 > .toggle rect {
  fill: var(--dry-border-color);
  transition: all 0.3s ease-in-out;
}
.lBe_oSTt_ZP6yOPJVcH0 > .toggle circle {
  fill: var(--dry-control-bg);
  transition: all 0.3s ease-in-out;
}
.lBe_oSTt_ZP6yOPJVcH0[data-on="true"] > .toggle rect {
  fill: var(--dry-primary);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `lBe_oSTt_ZP6yOPJVcH0`
};
export default ___CSS_LOADER_EXPORT___;
